import { useEffect, useState } from "react";
import { api, fmtDate } from "../lib/api";
import { PageHeader, DataTable } from "../components/Shell";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { DatePicker } from "../components/DatePicker";
import { Envelope, FileText } from "@phosphor-icons/react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import DeleteButton from "../components/DeleteButton";

export default function Reports() {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  const [list, setList] = useState([]);
  const load = () => api.get("/reports").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const today = new Date();
  const firstOfMonth = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().slice(0, 10);
  const lastOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0).toISOString().slice(0, 10);
  const mondayThisWeek = (() => {
    const d = new Date(today);
    const day = d.getDay() || 7;
    d.setDate(d.getDate() - day + 1);
    return d.toISOString().slice(0, 10);
  })();
  const sundayThisWeek = (() => {
    const d = new Date(today);
    const day = d.getDay() || 7;
    d.setDate(d.getDate() - day + 7);
    return d.toISOString().slice(0, 10);
  })();

  const [monthly, setMonthly] = useState({ periode_debut: firstOfMonth, periode_fin: lastOfMonth });
  const [weekly, setWeekly] = useState({ periode_debut: mondayThisWeek, periode_fin: sundayThisWeek });

  const gen = async (kind, params) => {
    try {
      await api.post(`/reports/${kind}`, null, { params: { ...params, send: true } });
      toast.success("Récapitulatif généré et envoyé");
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erreur");
    }
  };

  return (
    <div>
      <PageHeader
        testId="reports-header"
        title="Rapports"
        subtitle="Récapitulatifs personnel (mensuel) et sécurité (hebdo) envoyés par email."
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        <div className="surface p-6">
          <div className="flex items-center gap-2 mb-3">
            <FileText size={18} color="#fbbf24" />
            <div className="label-xs">Récapitulatif personnel - mensuel</div>
          </div>
          <div className="grid grid-cols-2 gap-3 mb-4">
            <div>
              <Label className="label-xs">Début</Label>
              <DatePicker
                testId="monthly-start"
                value={monthly.periode_debut}
                onChange={(v) => setMonthly({ ...monthly, periode_debut: v })}
              />
            </div>
            <div>
              <Label className="label-xs">Fin</Label>
              <DatePicker
                testId="monthly-end"
                value={monthly.periode_fin}
                onChange={(v) => setMonthly({ ...monthly, periode_fin: v })}
              />
            </div>
          </div>
          <Button data-testid="gen-monthly" onClick={() => gen("monthly-staff", monthly)} className="w-full bg-[#fbbf24] hover:bg-[#f59e0b] text-black">
            <Envelope size={16} className="mr-2" /> Générer & envoyer
          </Button>
        </div>
        <div className="surface p-6">
          <div className="flex items-center gap-2 mb-3">
            <FileText size={18} color="#fbbf24" />
            <div className="label-xs">Récapitulatif sécurité - hebdo</div>
          </div>
          <div className="grid grid-cols-2 gap-3 mb-4">
            <div>
              <Label className="label-xs">Début</Label>
              <DatePicker
                testId="weekly-start"
                value={weekly.periode_debut}
                onChange={(v) => setWeekly({ ...weekly, periode_debut: v })}
              />
            </div>
            <div>
              <Label className="label-xs">Fin</Label>
              <DatePicker
                testId="weekly-end"
                value={weekly.periode_fin}
                onChange={(v) => setWeekly({ ...weekly, periode_fin: v })}
              />
            </div>
          </div>
          <Button data-testid="gen-weekly" onClick={() => gen("weekly-security", weekly)} className="w-full bg-[#fbbf24] hover:bg-[#f59e0b] text-black">
            <Envelope size={16} className="mr-2" /> Générer & envoyer
          </Button>
        </div>
      </div>

      <DataTable
        columns={[
          { title: "Date génération", render: (r) => fmtDate(r.date_generation) },
          { title: "Type", key: "type_recap" },
          { title: "Période début", render: (r) => fmtDate(r.periode_debut) },
          { title: "Période fin", render: (r) => fmtDate(r.periode_fin) },
          { title: "Email manageuse", render: (r) => (r.email_envoye_manageuse ? "✓" : "—") },
          { title: "Email patron", render: (r) => (r.email_envoye_patron ? "✓" : "—") },
          ...(isAdmin
            ? [{
                title: "",
                render: (r) => (
                  <DeleteButton
                    url={`/reports/${r.id}`}
                    label={`le rapport ${r.type_recap}`}
                    onDone={load}
                    testId={`delete-report-${r.id}`}
                  />
                ),
              }]
            : []),
        ]}
        rows={list}
        rowKey="id"
      />
    </div>
  );
}
